// extracted by mini-css-extract-plugin
export var container = "languages-module--container--qixqU";
export var flag = "languages-module--flag--HX4gb";
export var imgContainer = "languages-module--imgContainer--wTzHb";
export var language = "languages-module--language--HG6tN";
export var open = "languages-module--open--nlTIH";
export var section = "languages-module--section--io1+H";